import * as types from '../constants/ActionTypes'
import moment from 'moment'
import _ from 'lodash'

import * as colors from 'material-ui/styles/colors';

const roumuInitalState = {
  processing: false,
  roumuDialog: false,
  formOpen: false,
  formData: null,
  searchText: '',


  events: null,
  removeEvents: null,
  approval: {date: '', open: false},

  alertOpen: false,

  //SUB Holiday
  subHolidayId: null,
  subHolidayDate: null,
  workHolidayId: null,
  workHolidayDate: null,
  workHolidayMode: null,
  subHolidayFormOpen: false,
  subHolidayFormEdit: false,
  workHolidayDates: [],
  holidayDates: [],


  kenmeiCodeDataSource: [],
  kenmeiCodes: [],
  currentKenmei: {
    kenmeiName: "ー",
    branchOfficeName: "ー",
    departmentName: "ー",
    customerName: "ー",
    constructionName: "ー",
    address: "ー",
  },

  yosanCosts: [],
  workHoliday: [],
  editUserId: null,
  editUserName: '',

  currentPaidHoliday: {}
}

const getApprovalUserName = (approvalUserName, add) => {

  if (!approvalUserName) {
    return add
  }

  if (approvalUserName.indexOf(add) == -1) {
    return approvalUserName + "__br__" + add
  }

  return approvalUserName;

}

const setApproval = (approvalData, baseDate, status, approvalUserName) => {

  const matchApproval = approvalData[baseDate]

  if (matchApproval) {

    let approval = matchApproval.approval
    if (approval == 0) {
      if (status == 0) {
        approval = 0
      } else {
        approval = 1
      }
    } else if (approval == 2) {
      if (status == 0) {
        approval = 1
      } else {
        approval = 2
      }
    }

    let approvalUserNames = matchApproval.approvalUserNames

    if (approvalUserName) {
      if (!_.includes(approvalUserNames, approvalUserName)) {
        approvalUserNames.push(approvalUserName)
      }
    }

    approvalData[baseDate] = {
      baseDate: baseDate,
      approval: approval,
      date: baseDate,
      approvalUserNames: approvalUserNames
    }

  } else {

    let approval
    if (status == 0) {
      approval = 0
    } else {
      approval = 2
    }
    approvalData[baseDate] = {
      baseDate: baseDate,
      approval: approval,
      date: baseDate,
      approvalUserNames: approvalUserName ? [approvalUserName] : []
    }
  }

}

const getEventColor = (kind, status, startTime) => {

  switch(kind) {
    case 2 :
      if (!startTime) {
        return colors.pink100
      }
      break
    case 4 :
    case 5 :
    case 10 :
    case 11 :
      return colors.blue200
    case 6 :
    case 7 :
    case 8 :
    case 9 :
      return colors.green300
    default:
  }

  switch(status) {
    case 0 :
      return colors.pink400
    case 1 :
      return colors.grey600
    default:
  }
}

const getEventTitle = (kind) => {
  switch(kind) {
    case 1 :
      return "通常出勤"
    case 2 :
      return "祝休日"
    case 3 :
      return "振替休暇"
    case 4 :
      return "代休 (全休)"
    case 5 :
      return "代休（半休)"
    case 6 :
      return "有給（全休）"
    case 7 :
      return "有給（半休）"
    case 8 :
      return "特別休暇（有給）"
    case 9 :
      return "特別休暇（無休）"
    case 10 :
      return "給与振替 (8)"
    case 11 :
      return "給与振替（4)"
    default:
  }
}

const getApprovalInfo = (approval) => {

    switch(approval) {
      case 0 :
        return {
          title: '承認待',
          color: colors.pink400
        }
      case 1 :
        return {
          title: '一部承認待',
          color: colors.pink400
        }
      case 2 :
        return {
          title: '承認済',
          color: colors.grey600
        }
      default:
    }
}

const getEndTime = (startTime, endTime) => {

  if (startTime.format('yyyyMMdd') !== endTime.format('yyyyMMdd')) {
      const h = endTime.format('HH');
      const m = endTime.format('mm');
      return (Number(h) + 24) + ":" + m;
  }

  return endTime.format('HH:mm');
}

const roumu = (state = roumuInitalState, action) => {
  switch(action.type) {

    case types.REDUCER_ROUMU_FORM_RESET :

      return Object.assign({}, state, {
        formData: {"date": state.formData.date},
        currentKenmei: roumuInitalState.currentKenmei
      })

    case types.REDUCER_ROUMU_FORM_NEXT :

      const newFormData = Object.assign({}, action.payload.formData, {
        startTime: action.payload.formData.endTime,
        endTime: null
      })

      return Object.assign({}, state, {
        formData: newFormData,
      })

    case types.REDUCER_ROUMU_SUB_HOLIDAY_FORM_OPEN:
    case types.REDUCER_ROUMU_SUB_HOLIDAY_FORM_CLOSE:
    case types.REDUCER_ROUMU_UPDATE_STORE:
    case types.REDUCER_ROUMU_FORM_OPEN :
    case types.REDUCER_ROUMU_FORM_CLOSE :
    case types.REDUCER_ROUMU_REMOVE_EVENTS :
    case types.REDUCER_ROUMU_APPROVAL_DIALOG_OPEN :
    case types.REDUCER_ROUMU_APPROVAL_DIALOG_CLOSE :
    case types.REDUCER_ROUMU_ALERT_DIALOG_OPEN :
    case types.REDUCER_ROUMU_ALERT_DIALOG_CLOSE :

      return Object.assign({}, state, action.payload)

    case types.REDUCER_ROUMU_SET_EVENTS :

      const {events} = action.payload
      
      let workHolidayData = {}

      //承認イベント作成
      let approvalData = {}
      events.forEach((x) => {
        if (x.kind == 2 && !x.startTime) {
          return
        }
        setApproval(approvalData, x.date, x.status, x.approvalUserName)
      })

      const convApproval = Object.keys(approvalData).length ? Object.keys(approvalData).map((key) => {

        const x = approvalData[key]
        const approvalInfo = getApprovalInfo(x.approval)

        return {
          allDay: true,
          order: 0,
          eventType: 'approval',
          title: approvalInfo.title,
          approvalUserNames: x.approvalUserNames,
          color: approvalInfo.color,
          start: moment(x.date, 'YYYY/MM/DD'),
          approval: x.approval,

          date: x.date,
          rand: moment().unix()
        }

      }) : []

      const convAllTime = events ? events
      .map(x => {
          return x.date
      })
      .filter((x, i, self) => {
          return self.indexOf(x) === i
      }).map((date) => {

          const allTime = events.filter(event => {
              return event.date == date
          }).map(event => {
              if (!event.startTime) {
                  return 0
              }

              return event.diff;
              // return moment(event.endTime).diff(moment(event.startTime), 'minutes')

          }).reduce((a, b) => a + b)

          if (allTime == 0) {
            return
          }

          const allTimeHours = Math.floor(allTime / 60)
          const allTimeMinutes = allTime % 60

          return {
              allDay: true,
              order: 2,
              eventType: 'diff',
              title: `${allTimeHours >= 1 ? allTimeHours + '時間': ''} ${allTimeMinutes != 0 ? allTimeMinutes + '分' : ''}`,
              color: colors.grey400,
              start: moment(date, 'YYYY/MM/DD'),
              date: date,
              rand: moment().unix()
          }

      }).filter(x => x) : []

      let tmpKind = []

      //労務イベント作成(時間無し)
      const convAllEvents = events ? events.map((x) => {

        //if (x.kind == 1 || tmpKind.indexOf(x.kind + x.date) >= 0) {
        if (x.kind == 1 || (x.kind == 2 && x.startTime)) {
          return
        }

        let eventType = 'holidayAllDay'
        if (x.kind == 2) {
          eventType = 'holidayAllDayNotDialog'
        }

        tmpKind.push(x.kind + x.date)

        return {
          allDay: true,
          order: 1,
          //eventType: x.startTime ? 'holidayAllDayWork' : 'holidayAllDay',
          eventType: eventType,
          title: getEventTitle(x.kind),
          color: getEventColor(x.kind, x.status, x.startTime),
          start: moment(x.date, 'YYYY/MM/DD'),

          id: x.id,
          date: x.date,
          comment: x.comment,
          kind: x.kind,
          status: x.status,
          workHolidayDate: x.workHolidayDate,
          diff: x.diff,
          rand: moment().unix(),
          overTimeList: x.overTimeList
        }

      }).filter(x => x) : []

      //労務イベント作成(時間有り)
      const convEvents = events ? events.map((x) => {

        if (!x.startTime) {
          return
        }

        const startTimeMoment = moment(x.startTime, 'YYYY/MM/DD HH:mm:ss')
        const endTimeMoment = moment(x.endTime, 'YYYY/MM/DD HH:mm:ss')

        return {
          allDay: false,
          eventType: 'basic',
          order: 1,
          title: `[${x.kenmeiCode}] ${x.kenmeiName}`,
          color: getEventColor(x.kind, x.status, x.startTime),
          start: startTimeMoment.format(),
          end: endTimeMoment.format(),

          id: x.id,
          yosanId: x.yosanId,
          kenmeiId: x.kenmeiId,
          kenmeiCode: x.kenmeiCode,
          kenmeiName: x.kenmeiName,
          customerName: x.customerName,
          date: startTimeMoment.format('YYYY/MM/DD'),
          startTime: startTimeMoment.format('HH:mm'),
          endTime: getEndTime(startTimeMoment, endTimeMoment),
          comment: x.comment,
          kind: x.kind,
          workId: x.workId,
          costId: x.costId,
          status: x.status,
          overTimeList: x.overTimeList,
          directWork: x.directWork,
          directHome: x.directHome,
        }

      }).filter(x => x) : []

      return Object.assign({}, state, {events: convApproval.concat(convEvents).concat(convAllTime).concat(convAllEvents)})

    case types.REDUCER_ROUMU_SET_SELECT_DATA :

      const {kenmeiCodes, works} = action.payload

      let avarableKenmeiCodes =  kenmeiCodes.filter(x => x.status !=3)

      const kenmeiCodeDataSource = avarableKenmeiCodes.map((x) => {
        return {
          textKey: `${x.code} - ${x.name}`,
          valueKey: x.code
        }
      }).filter(x => x)

      return Object.assign({}, state, 
        {
          kenmeiCodes: avarableKenmeiCodes,
          kenmeiCodeDataSource: kenmeiCodeDataSource,
          works: works
        }
      )

    case types.REDUCER_ROUMU_SET_WORK_HOLIDAY_DATES :

      const {workHolidayDates} = action.payload

      const convWorkHolidayDates = workHolidayDates.map(x => {
        return {
          id: x.id,
          date: moment(x.workHolidayDate).format('YYYY/MM/DD'),
          mode: x.mode
        }
      })

      return Object.assign({}, state, {workHolidayDates: convWorkHolidayDates})

    case types.REDUCER_ROUMU_SET_HOLIDAY_DATES :

      const {holidayDates} = action.payload

      const convHolidayDates = holidayDates.map(x => {
        return {
          id: x.id,
          date: moment(x.holidayDate).format('YYYY/MM/DD'),
        }
      })

      return Object.assign({}, state, {holidayDates: convHolidayDates})

    case types.REDUCER_ROUMU_SET_YOSAN_COSTS :
      const {id, yosanCosts, disable} = action.payload

      let convYosanCosts = yosanCosts ? yosanCosts.map(x => {

        return {
          text: x.costName,
          costId: x.costId,
          yosanId: x.yosanId
        }
      }).filter(x => x) : []

      if (disable) {
        convYosanCosts = [{text: '完工物件です。'}]
      } else if (convYosanCosts.length === 0) {
        convYosanCosts = [{text: '労務予算がありません。'}]
      }

      return Object.assign({}, state, {yosanCosts: convYosanCosts})

    case types.REDUCER_ROUMU_SET_WORK_HOLIDAY :

      const {workHoliday} = action.payload

      let convWorkHoliday = workHoliday ? workHoliday.map(x => {

        let text = x.date
        if (x.diff == 240) {
          text = `${x.date} 分 (半日）`
        } else if (x.diff == 480){
          text = `${x.date} 分 (全日）`
        } else {
          return
        }

        return {
          text: text,
          diff: x.diff,
          date: x.date
        }
      }).filter(x => x) : []

      if (convWorkHoliday.length === 0) {
        convWorkHoliday = [{text: '休出情報がありません', diff:0}]
      }

      return Object.assign({}, state, {workHoliday: convWorkHoliday})

    case types.REDUCER_ROUMU_SET_CURRENT_KENMEI :

      const {currentKenmei} = action.payload
      // const newFormData = Object.assign({}, state.formData, yosanId: ''})

      //return Object.assign({}, state, {currentKenmei: currentKenmei, formData: newFormData})
      return Object.assign({}, state, {currentKenmei: currentKenmei})

    case 'REDUCER_ROUMU_REGIST_START':
      return Object.assign({}, state, {processing: true})
    case 'REDUCER_ROUMU_REGIST_END':
      return Object.assign({}, state, {processing: false})
    case 'REDUCER_ROUMU_DIALOG_OPEN':
      return Object.assign({}, state, {roumuDialog: true})
    case 'REDUCER_ROUMU_DIALOG_CLOSE':
      return Object.assign({}, state, {roumuDialog: false})
    case 'REDUCER_ROUMU_ADD_EVENT':
      return Object.assign({}, state, {event: action.payload.event})
    case 'REDUCER_ROUMU_RESET_EVENT':
      return Object.assign({}, state, {event: null})
    default:
      return state
  }
}

export default roumu


// WEBPACK FOOTER //
// ./src/reducers/roumu.js